import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../store/core/dialogSlice';

const Dialog = () => {
  const dispatch = useDispatch();
  const state = useSelector(({ core }) => core.dialog.state);
  const options = useSelector(({ core }) => core.dialog.options);

  return (
    <Modal
      isOpen={state}
      contentLabel='Dialog'
      appElement={document.getElementById('root')}
      onRequestClose={() => (options.close ? dispatch(closeDialog()) : null)}
      className={options.class}
      overlayClassName={options.overlay}
      style={{
        transform: state ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: state ? '1' : '0',
      }}
    >
      {options.children}
    </Modal>
  );
};

export default Dialog;
